(function () {
  const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxrM7B-YcOwSvXKnyf34OTIMEB7aPh9PPdl-va1X2hht-8oM2aPa-6Ls-M3bkjvYbRw/exec';

  document.addEventListener('dietxp:report-ready', function (event) {
    const report = event.detail || {};
    const person = report.d || {};
    let phone = String(person.phone || '').replace(/\D/g, '');
    if (phone.length === 12 && phone.slice(0, 2) === '91') phone = phone.slice(2);
    const contact = {
      name: String(person.name || '').trim(),
      email: String(person.email || '').trim(),
      phone: phone
    };

    if (!contact.name || !contact.email || !/^[6-9]\d{9}$/.test(contact.phone)) return;
    const fingerprint = [contact.name, contact.email, contact.phone].join('|').toLowerCase();
    try {
      if (sessionStorage.getItem('dietxp_contact_sync_v1') === fingerprint) return;
      sessionStorage.setItem('dietxp_contact_sync_v1', fingerprint);
    } catch (error) {}

    fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(contact)
    }).catch(function (error) {
      try { sessionStorage.removeItem('dietxp_contact_sync_v1'); } catch (storageError) {}
      console.error('DietXP contact sync failed', error);
    });
  });
})();
